export const config = {
  BASE_URL: "https://api.abhi.ae/production-",
};
